
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorOpenHand as ObiCursorOpenHandElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-open-hand.js';
 
 
 

 
 export const ObiCursorOpenHand = createComponent({
   react: React,
   tagName: 'obi-cursor-open-hand',
   elementClass: ObiCursorOpenHandElement,
   events: {
     
   }
  });
 
 